import { AntimalwareAntiTamperingPanelBaseDataProvider } from './AntimalwareAntiTamperingPanelBaseDataProvider';
import { AntimalwareAntiTamperingPanelWebComponentSchema } from '../types';

export class AntimalwareAntiTamperingPanelGzDataProvider extends AntimalwareAntiTamperingPanelBaseDataProvider {
  async getDataForView(): Promise<AntimalwareAntiTamperingPanelWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
